module.exports = __webpack_public_path__ + "img/bebidas.fecd01ee.svg";